<template>
  <div class="already-receive-list">
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="分批申请单号:" prop="deliveryNum">
        <el-input v-model.trim="searchForm.deliveryNum" placeholder="请输入分批申请单号" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="masterContractNum">
        <el-input v-model.trim="searchForm.masterContractNum" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入合同编号" @blur="salaryChange" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="masterProjectName">
        <el-input v-model.trim="searchForm.masterProjectName" placeholder="请输入发货单号" />
      </el-form-item>
      <el-form-item label="申请日期:" prop="startTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="deliveryNum" label="分批申请单号" align="left" width="140" fixed="left">
          <template v-slot="{row}">
            <el-button v-if="row.amountDisplayFlag" type="text" @click="numberClick(row)">
              {{ row.deliveryNum }}
            </el-button>
            <el-button v-else type="text" @click="numberClickTwo(row)">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterContractNum" label="合同编号" align="left" width="140" fixed="left">
          <template v-slot="{row}">
            <el-button v-if="row.amountDisplayFlag" type="text" @click="numberContract(row)">
              {{ row.masterContractNum }}
            </el-button>
            <el-button v-else type="text" @click="numberContractTwo(row)">
              {{ row.masterContractNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterProjectName" label="项目名称" align="left" min-width="130" />
        <!-- <el-table-column prop="receiptAddress" label="收货地址" align="left" width="150" /> -->
        <el-table-column label="分批发货金额" align="right" width="130" header-align="left">
          <template v-slot="{row}">
            <span v-if="row.amountDisplayFlag">{{ row.amountSum }}</span>
            <span v-else>——</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请日期" align="left" min-width="140" />
        <el-table-column prop="approveType" label="状态信息" min-width="90" align="left" />
        <el-table-column prop="approveTime" label="驳回日期" align="left" width="140" />
        <el-table-column prop="approveComment" label="驳回原因" align="left" min-width="140" />
        <el-table-column label="操作" align="left" width="130" fixed="right">
          <template v-slot="{row}">
            <el-button v-if="row.approveType !=='代理商提交待确认'" type="text" style="margin-top:10px" @click="exit(row)">
              编辑
            </el-button>
            <el-button v-else type="text" style="margin-top:10px" @click="handle(row)">
              办理
            </el-button>
            <el-button v-if="row.approveType !=='代理商提交待确认'" type="text" style="color: red; margin-top:10px" :loading="loadingBach" @click="backList(row)">
              废弃
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="发货产品清单" :visible.sync="receiptProductVisible" width="800px">
      <delivery-receipt-product-list
        v-if="receiptProductVisible"
        :receipt-number="receiptNumber"
        :contract-code="contractCode"
        :order-number="orderNumber"
      />
    </el-dialog>
    <el-dialog title="回单信息" :visible.sync="receiptVisible" width="700px">
      <receipt-list v-if="receiptVisible" :receipt-form="receiptForm" :is-show="isShow" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="receiptVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <partShipCheck :id="partId" :dialog-form-visible="dialogFormVisible" @on-status-dialog="updataDialogFormVisible" />
    <partShipCheckTwo :id="partId" :dialog-form-visible="dialogFormVisibleTwo" @on-status-dialog="updataDialogFormVisibleTwo" />
    <editBatch :id="partIdEdit" :dialog-visible-exit="dialogVisibleExit" :amount-display-flag="amountDisplayFlag" @on-exit-dialog="onExitDialog" @on-exit-fresh="freshData" />
    <fpfhCheck :fpfh-dialog="fpfhDialog" :row-data="rowdata" :contract-type="conType" :fpfh-id="fpfhIdHandel" @on-status-dialog="updataDialogFpfh" />
  </div>
</template>

<script>
import {
  rejectAppliedPartialInvoice,
  revokeApply,
  getContractInfoByDocumentId,
  partialInvoiceInvalid,
  checkSplitAndFreightPayType
} from '@/API/index.js';
// import API from '@/API/international.js';
import deliveryReceiptProductList from './deliveryReceiptProductList';
import receiptList from './receiptList';
import partShipCheck from '../../partShipCheck';
import fpfhCheck from './common/fpfhDialog.vue';
import partShipCheckTwo from '../order/partShipCheck';
import editBatch from './common/editBatch';
import eventBus from '@/libs/eventBus.js';
export default {
  name: 'AlreadyReceiveList',
  data () {
    return {
      loadingBach: false,
      tableLoading: false,
      receiptProductVisible: false,
      // 定义组件
      dialogFormVisible: false,
      dialogFormVisibleTwo: false,
      dialogFormVisibleLogist: false,
      dialogVisibleExit: false,
      fpfhDialog: false,
      exportUrl: '',
      formNum: {},
      searchForm: {
        deliveryNum: '',
        masterContractNum: '',
        masterProjectName: '',
        startTime: '',
        endTime: ''
      },
      rowdata: {},
      tableData: [],
      conType: '',
      partId: '',
      partIdEdit: '',
      amountDisplayFlag: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      receiptNumber: '',
      contractCode: '',
      orderNumber: '',
      receiptVisible: false,
      receiptForm: {},
      isShow: false,
      textarea: '',
      fpfhIdHandel: 0
    };
  },
  components: {
    deliveryReceiptProductList,
    receiptList,
    partShipCheck,
    editBatch,
    partShipCheckTwo,
    fpfhCheck
  },
  methods: {
    // blur
    salaryChange (e) {
      this.searchForm.masterContractNum = (e.target.value || '').trim();
    },
    initData () {
      this.tableLoading = true;
      let params = {
        deliveryNum: this.searchForm.deliveryNum,
        masterContractNum: this.searchForm.masterContractNum,
        masterProjectName: this.searchForm.masterProjectName,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        pageSize: this.page.pageSize,
        pageIndex: this.page.currentPage
      };
      rejectAppliedPartialInvoice(params).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
          this.tableData = json.data.list;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs['searchForm'].resetFields();
      this.searchForm.endTime = '';
      this.page.currentPage = 1;
      this.initData();
    },
    doSearch () {
      this.page.currentPage = 1;
      this.initData();
    },
    // 撤销按钮
    removeApply (row) {
      this.$confirm('是否撤销申请?', '提示', {
        confirmButtonText: '撤销',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用撤销接口  查看返回状态
        this.revokeHttp(row.id);
      });
    },
    // 撤销接口
    revokeHttp (id) {
      this.loading = true;
      revokeApply({ 'id': id }).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '撤销成功 !'
          });
          this.initData();
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    handerSizeChange () {
      this.page.currentPage = 1;
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    pickerOptions () {

    },
    toReceiptList (row) {
      this.receiptVisible = true;
      this.receiptForm = row;
    },
    numberClick (row) {
      this.partId = row.id;
      this.dialogFormVisible = true;
    },
    numberClickTwo (row) {
      this.partId = row.id;
      this.dialogFormVisibleTwo = true;
    },
    numberContract (row) {
      this.$router.push({ name: 'ContractInfo', params: { contractNum: row.masterContractNum }, query: { id: row.masterContractId, masterProjectName: row.masterProjectName } });
    },
    numberContractTwo (row) {
      getContractInfoByDocumentId(row.documentId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data.contractNum) {
            this.$router.push({
              name: 'logistics',
              params: {
                contractNum: json.data.contractNum
              },
              query: { id: json.data.id, masterProjectName: json.data.projectName }
            });
          } else {
            this.$notify.error({
              message: '暂未生成合同，请稍后再试。'
            });
          }
        }
      }).catch(() => {

      });
    },
    //
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    updataDialogFormVisibleTwo (val) {
      this.dialogFormVisibleTwo = val;
    },
    updataDialogFpfh (val) {
      this.fpfhDialog = val;
      this.initData();
    },
    // 组件事件
    onExitDialog (val) {
      this.dialogVisibleExit = val;
    },
    freshData () {
      this.initData();
    },
    exit (row) {
      this.partIdEdit = row.id;
      this.amountDisplayFlag = row.amountDisplayFlag;
      this.dialogVisibleExit = true;
    },
    handle (row) {
      // 传id
      this.fpfhIdHandel = row.id;
      this.rowdata = row;
      this.fpfhDialog = true;
      this.conType = row.contractType;
    },
    // 废弃
    backList (row) {
      let parmas = { id: row.id };
      checkSplitAndFreightPayType(parmas).then((res) => {
        let json = res.data;
        if (json.data) {
          this.$confirm('此单运费差价使用返利支付，废弃时此单关联的其他发货单将全部废弃', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.backListT(row);
          }).catch(() => {
          });
        } else {
          this.backListT(row);
        }
      }).catch(() => {
        this.backListT(row);
      });
    },
    backListT (row) {
      this.loadingBach = true;
      partialInvoiceInvalid({ id: row.id, processState: 6 }).then((res) => {
        let json = res.data;
        this.loadingBach = false;
        if (json.status === '200') {
          this.initData();
        } else {
          this.initData();
        }
      }).catch((res) => {
        console.log(res);
        this.loadingBach = false;
      });
    }
  },
  mounted () {
    this.initData();
    eventBus.$on('changescom', () => {
      this.initData();
    });
  }
};
</script>

<style scoped>

</style>
